module.exports = __webpack_public_path__ + "static/media/folder.f8a3bc93.svg";